<template>
  <div class="me-2" v-if="id">
    <button class="ms-auto btn btn-secondary" @click="onGetUploads">
      <i class="bi bi-card-checklist" />
    </button>
  </div>
</template>
<script setup>
import { useApi } from '@provise/composables/api'
import { useModalStack } from '@provise/stores/modalstack'
import UploadsList from '@/components/upload/uploads_list.vue'

const props = defineProps({
  id: Number,
})

const { push: openModal } = useModalStack()
const { model: uploadsModel, refresh } = useApi({
  url: `complaints/${props.id}/uploads`,
})

defineExpose({ refresh })

async function onGetUploads() {
  await refresh()
  openModal({
    component: UploadsList,
    props: {
      headerText: 'Документы по обращению',
      list: uploadsModel.value.data,
    },
  })
}
</script>
